/** Semver клиента из `package.json`, подставляется Vite при сборке. */
export function getAppVersionLabel(): string {
  const v = import.meta.env.VITE_APP_VERSION;
  return v ? `v${v}` : "v0.0.0";
}
